//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[0,"ApplyStockOffsetOnBothSides",1,0],[0,"AxialShiftForFinishPasses",1,0],[0,"FinishPasses",1,0],[0,"MultipleDepths",1,0],[0,"NumberOfDepths",1,0],[0,"NumberOfFinishPasses",1,0],[0,"OutputType",1,0],[1,"SideStockOffset",0,"CAM.InheritableToolDepBuilder",0]],[],[]];
SPLM.CAM.BladeFinishPass = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BladeFinishPass";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BladeFinishPass.BladeFinishPassesType = Object.freeze({
    "None" : "None", "LeftAndRight" : "LeftAndRight", "Left" : "Left", "Right" : "Right"});

SPLM.CAM.BladeFinishPass.FinishPassesOutputType = Object.freeze({
    "InfillsOnly" : "InfillsOnly", "FinishPassesOnly" : "FinishPassesOnly", "InfillsAndFinishPasses" : "InfillsAndFinishPasses"});

SPLM.CAM.BladeFinishPass.FinishPassesMultipleDepthsType = Object.freeze({
    "None" : "None", "AlongToolAxis" : "AlongToolAxis", "AlongContact" : "AlongContact"});

export default SPLM;